import { useDefaultValue, useStateManagementSlice } from '@gef-ui/context-defaults';
import { useMemo } from 'react';
const sliceName = 'versionInfo';
/**
 * Abstract hook for getting BE/FE versions, uses stateManagement.versionInfo slice implementation
 * @param config optional object that will be passed to the implementation
 * @returns {{be: *, fe: *}|{}}
 */ const useVersionInfo = (inProps = {})=>{
    const props = useDefaultValue({
        inProps,
        slice: 'VersionInfoCore',
        components: [
            'useVersionInfo'
        ]
    });
    const { useBeVersionInfoQuery, useFeVersionInfoQuery } = useStateManagementSlice(sliceName);
    const beVersions = useBeVersionInfoQuery(props);
    const feVersions = useFeVersionInfoQuery(props);
    const versionInfo = useMemo(()=>{
        return {
            be: beVersions,
            fe: feVersions
        };
    }, [
        beVersions,
        feVersions
    ]);
    return versionInfo || {};
};
export default useVersionInfo;
